/**
 * helper function to transform asts by a function operating on each bottom-level child node
 * @param node the ast root to transform on
 * @param func the transformer function
 */
export default function flatMapAst(node: any, func: (node: any) => any): any {
	// transform the node itself
	const newNode = func(node);

	// transform the children
	for (let i = 0; i < node.children.length; i++) {
		let child = node.children[i];

		// recurse into other nodes if found
		if (Array.isArray(child.children)) {
			child = flatMapAst(child, func);
		}

		newNode.children[i] = func(child);
	}

	return newNode;
}



// WEBPACK FOOTER //
// ./src/utils/flat_map_ast.ts